import { getAccess, getRefresh, setTokens, clearTokens } from "./auth";
import { API_BASE } from "./config";

async function refreshAccess() {
  const refresh = getRefresh();
  if (!refresh || refresh === "null" || refresh === "undefined") return null;

  const res = await fetch(`${API_BASE}/token/refresh/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refresh }),
  });

  if (!res.ok) return null;
  const data = await res.json();
  setTokens({ access: data.access });     // keep old refresh
  return data.access;
}

// Wrapper with auto-refresh + retry-once
export async function apiRequest(path, options = {}, retry = true) {
  const isFormData = typeof FormData !== "undefined" && options.body instanceof FormData;
  const headers = {
    ...(!isFormData && options.body ? { "Content-Type": "application/json" } : {}),
    ...(options.headers || {}),
  };

  const access = getAccess();
  if (access && headers.Authorization == null) {
    headers.Authorization = `Bearer ${access}`;
  }

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });

  // If unauthorized, try refresh once
  if (res.status === 401 && retry) {
    try {
      const body = await res.clone().json().catch(() => ({}));
      const isExpired =
        body?.code === "token_not_valid" ||
        (Array.isArray(body?.messages) && body.messages.some(m => m?.message?.toLowerCase().includes("expired")));

      if (isExpired) {
        const newAccess = await refreshAccess();
        if (newAccess) {
          const retryHeaders = { ...headers, Authorization: `Bearer ${newAccess}` };
          return fetch(`${API_BASE}${path}`, { ...options, headers: retryHeaders });
        }
      }
    } catch (_) {
      // ignore parse errors; fall through to logout
    }
    clearTokens();
    window.location.href = "/login";
    return res; // unreachable post-redirect, but keeps types happy
  }

  return res;
}
